import {fabric} from 'fabric';

// todo: need another refactor https://stackoverflow.com/questions/11272772/fabric-js-how-to-save-canvas-on-server-with-custom-attributes
export type FabricObjectIds = 'placedSymbolId' | 'schemaId' | 'symbolId' | 'areaId';
export enum DrawObjectType {
	area = 'area',
	schema = 'schema',
	symbol = 'symbol',
	placedSymbol = 'placedSymbol'
}

export interface FabricArea extends fabric.Polygon {
	areaId: string;
	drawType: DrawObjectType.area;
}

export interface FabricSchema extends fabric.Group {
	schemaId: string;
	drawType: DrawObjectType.schema;
}

export interface FabricSymbol extends fabric.Group {
	symbolId: string;
	drawType: DrawObjectType.symbol;
}
